const Validation = require('./validation')
module.exports = class Phone extends Validation {}
